import { Button } from 'components/common'
import { ICellRendererParams } from '@ag-grid-community/core'
import { useNavigate } from 'react-router-dom'
import { PAGE_UPDATE_STORE } from 'utils/constants'

type ActionCellRendererProps = {
  params: ICellRendererParams
  isEditor: boolean
  getStoreToDelete: (params: ICellRendererParams) => void
}

const ActionCellRenderer = ({
  params,
  isEditor,
  getStoreToDelete,
}: ActionCellRendererProps) => {
  const navigate = useNavigate()

  const handleEditStore = (storeId: string) => {
    navigate(`${PAGE_UPDATE_STORE.path}/${storeId}`)
    return
  }

  if (!isEditor) {
    return <></>
  }

  return (
    <div className="flex h-full items-center justify-center gap-3">
      <Button
        size="small"
        variant="outline"
        className="w-20"
        buttonText="Edit"
        type="button"
        onClick={() => handleEditStore(params.data._id)}
      />

      <Button
        size="small"
        className="w-20"
        buttonText="Delete"
        type="button"
        onClick={() => getStoreToDelete(params)}
      />
    </div>
  )
}

export default ActionCellRenderer
